'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaginationBoxView = require('./PaginationBoxView');

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-paginate/dist/index.js
// module id = 126
// module chunks = 0